import React from 'react';
import { ExclamationTriangleIcon } from '@heroicons/react/24/outline';
import VoiceModal, { ModalFooter } from './VoiceModal';
import { TEXT_MUTED, TEXT_PRIMARY } from './tokens';

/**
 * Themed confirmation.
 *
 * The module used seven raw `window.confirm()` calls — native OS dialogs in
 * an otherwise fully themed dark-mode app — for destructive actions like
 * releasing a phone number and deleting a SIP trunk. Native confirms also
 * can't say what will actually happen beyond a single line of text.
 *
 * Defaults to the danger variant because every current caller is destructive.
 */
const ConfirmDialog = ({
  open,
  onCancel,
  onConfirm,
  title = 'Are you sure?',
  message,
  confirmLabel = 'Confirm',
  variant = 'danger',
  loading = false,
}) => (
  <VoiceModal
    open={open}
    onClose={onCancel}
    title={title}
    size="sm"
    footer={
      <ModalFooter
        onCancel={onCancel}
        onConfirm={onConfirm}
        confirmLabel={confirmLabel}
        loading={loading}
        variant={variant}
      />
    }
  >
    <div className="flex gap-3">
      <div
        className={`flex-shrink-0 w-9 h-9 rounded-full flex items-center justify-center ${
          variant === 'danger' ? 'bg-red-500/10 text-red-500' : 'bg-amber-500/10 text-amber-500'
        }`}
      >
        <ExclamationTriangleIcon className="w-5 h-5" />
      </div>
      <div className="min-w-0 pt-1">
        <p className={`text-sm ${TEXT_PRIMARY}`}>{message}</p>
        {variant === 'danger' && (
          <p className={`text-[12px] mt-1.5 ${TEXT_MUTED}`}>This can't be undone.</p>
        )}
      </div>
    </div>
  </VoiceModal>
);

export default ConfirmDialog;
